import styled from 'styled-components';
import { colourPalette } from 'styles/styles';

/**
 * @deprecated Use Avatar instead
 */
export const UserIconStyle = {
  Container: styled.div<{ $colour?: string }>`
    width: 32px;
    min-width: 32px;
    height: 32px;
    display: flex;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    background-color: ${({ $colour }) => $colour || colourPalette.green500};
  `,
  Text: styled.span`
    color: white;
  `,
};
